<template>
  <div class="doggies">
    <h2>
      Hear From the <br />
      Doggies Themselves
    </h2>

    <div class="doggies_img">
      <img src="../assets/images/doggies-gif.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Doggies",
};
</script>

<style lang="scss" src="../styles/doggies.scss"></style>
